import * as FullScreen from "../public/icons/organigram-fullscreen.svg";
import * as NormalScreen from "../public/icons/normalScreen.png";
const Utils = {
    // dragstart
    nodeDragStart(e){
        draggedItem = item;
        setTimeout(() => item.classList.add("dragging"), 0);
        e.dataTransfer.effectAllowed = "move";
    },
    // dragend
    nodeDragEnd(e){
        draggedItem.classList.remove("dragging");
        placeholder.remove();
        draggedItem = null;
    },
    // dragover
    nodeDragOver(e){
        e.preventDefault();
        const list = document.getElementById("sortableList");
        const draggingOver = e.target;

        if (draggingOver.classList.contains("list-item")) {
            list.insertBefore(placeholder, draggingOver);
        }
    },
    // dragenter
    nodeDragEnter(e){
        if (e.target.classList.contains("list-item")) {
            e.target.classList.add("drag-over");
        }
    },
    // dragleave
    nodeDragLeave(e){
        e.target.classList.remove("drag-over");
    },
    // drop
    nodeDrop(e){
        e.target.classList.remove("drag-over");
        const list = document.getElementById("sortableList");

        if (placeholder.parentNode === list) {
            list.insertBefore(draggedItem, placeholder);
            placeholder.remove();
        }
    },
    // zoom in and zoom out screen
    toggleZoomScreen(_container,_target,_parent){
        if (!_target._viewportState) {
            _target._viewportState = {
                scale: 1,
                translateX: 0, // CRITICAL FIX: Removed '-50%' string which breaks JS Math
                translateY: 0
            };
            
            // Auto-center safely using pixel math
            setTimeout(() => {
                if(_container && _target) {
                    _target._viewportState.translateX = (_container.offsetWidth - _target.offsetWidth) / 2;
                    _target.style.transform = `translate(${_target._viewportState.translateX}px, ${_target._viewportState.translateY}px) scale(${_target._viewportState.scale})`;
                }
            }, 100);
        }
        // Create container for zoom controls
        const zoomControlBody = document.createElement('div');
        zoomControlBody.style.cssText = `display:flex; gap:8px; align-items:center;`;

        // Create zoom-in button
        const buttonCSS = {
            padding: '4px 8px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            cursor: 'pointer',
            background: '#fff',
        }
        const zoomInBtn = document.createElement('button');
        zoomInBtn.textContent = '+';
        this.applyStyles(zoomInBtn,buttonCSS);

        // Create zoom-out button
        const zoomOutBtn = document.createElement('button');
        zoomOutBtn.textContent = '-';
        this.applyStyles(zoomOutBtn,buttonCSS);

        zoomControlBody.append(zoomOutBtn, zoomInBtn);
        _parent.prepend(zoomControlBody);

        const viewport = this.moveViewport(_container, _target, {
            sharedState: _target._viewportState,
            isActive: true
        });
        zoomInBtn.addEventListener('click', () => viewport.zoomIn());
        zoomOutBtn.addEventListener('click', () => viewport.zoomOut());
    },
    createElem : (tag, classes = [], id = "", content = "", attributes = {}) => {
        const elem = document.createElement(tag);
        if (classes.length) elem.classList.add(...classes);
        if (id) elem.id = id;
        if (content) elem.innerHTML = content;
        Object.keys(attributes).forEach(key => elem.setAttribute(key, attributes[key]));
        return elem;
    },
    applyStyles(elem, styles) {
        Object.keys(styles).forEach(key => {
            elem.style[key] = styles[key];
        });
    },
    createSuggestiveDropDown(suggestions,id,placeholder) {
        const container = this.createElem('div');
        const inputBox = this.createElem('input', '', '', '', {
            placeholder: placeholder,
            list: id,
        })
        const datalist = this.createElem('datalist', '', '', '', { id: id });
        suggestions.forEach(skill => {
            const option = this.createElem('option', '', '', '', { value: skill });
            datalist.appendChild(option);
        });
        this.applyStyles(inputBox,{border:'none',fontFamily:'inherit',borderBottom:`3px solid #0000001A`,padding:'10px 5px',width:'100%'});
        container.append(inputBox,datalist);
        return container;
    },
    debounce(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    },
    throttle(func, wait) {
        let lastCall = 0;
        return function (...args) {
            const now = Date.now();
            if (now - lastCall >= wait) {
                lastCall = now;
                func.apply(this, args);
            }
        };
    },
    JSONToCSV(e, t, a) {
        var r = "object" != typeof e ? JSON.parse(e) : e,
            s = "";
        if (((s += t + "\r\n\n"), a)) {
            let e = "";
            for (let t in r[0]) e += t + ",";
            (e = e.slice(0, -1)), (s += e + "\r\n");
        }
        for (let e = 0; e < r.length; e++) {
            let t = "";
            for (let a in r[e]) t += '"' + r[e][a] + '",';
            t.slice(0, t.length - 1), (s += t + "\r\n");
        }
        if ("" != s) {
            var o = "MyReport_";
            (o += t.replace(/ /g, "_")), (o += new Date());
            var n = "data:text/csv;charset=utf-8," + escape(s),
                i = document.createElement("a");
            (i.href = n), (i.style = "visibility:hidden"), (i.download = o + ".csv"), document.body.appendChild(i), i.click(), document.body.removeChild(i);
        } else alert("Invalid data");
    },
    CSVToJSON(e) {
        for (var t = e.split("\n"), a = [], r = t[0].split(","), s = 1; s < t.length; s++) {
            for (var o = {}, n = t[s].split(","), i = 0; i < r.length; i++) o[r[i].trim()] = n[i].trim();
            a.push(o);
        }
        return JSON.stringify(a);
    },
    toggleFullScreen(e, t) {
        const a = this.createElem("button", ["toggleFullScreen","cursor-pointer"], "toggle-full-screen", ""),
            r = this.createElem("img", ["toggleScreenIcon"], "", "");
        r.setAttribute("src", document.fullscreenElement ? NormalScreen : FullScreen),
            r.setAttribute("width", "100%"),
            r.setAttribute("height", "100%"),
            a.append(r),
            document.querySelector("#" + e).append(a),
            (a.style.cssText = "\n            border: none;\n            background: none;\n            width: 25px;\n            height: 25px;\n            margin: 10px;\n        "),
            a.addEventListener("click", function () {
                let e = document.getElementById(t);
                document.fullscreenElement
                    ? (r.setAttribute("src", FullScreen), document.exitFullscreen())
                    : (r.setAttribute("src", NormalScreen),
                      e.requestFullscreen().catch((e) => {
                          alert(`Error attempting to enable full screen mode: ${e.message} (${e.name})`);
                      }));
            });
    },
    randomString : (e) => {
        for (var t = "", a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", r = 0; r < e; r++) t += a.charAt(Math.floor(62 * Math.random()));
        return t;
    },
    parseNumber : (value) => {
        if (String(value).includes('.')) {
            return parseFloat(value);
        } else {
            return parseInt(value);
        }
    },
    playBellSound : (maxFreq,minFreq,type) => {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();

        // Create an oscillator for the bell sound
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();

        // Configure oscillator to generate a bell-like sound
        oscillator.type = type; // type of wave for sound
        oscillator.frequency.setValueAtTime(maxFreq || 880 , audioContext.currentTime); // Start at 880 Hz (A5 note)
        oscillator.frequency.exponentialRampToValueAtTime(minFreq || 440, audioContext.currentTime + 0.5); // Drop to 440 Hz (A4 note)

        // Control volume with the gain node
        gainNode.gain.setValueAtTime(1, audioContext.currentTime); // Start at full volume
        gainNode.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + 0.5); // Fade out over 0.5 seconds

        // Connect oscillator to gain node, then to the audio context destination
        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);

        // Start and stop the oscillator
        oscillator.start(audioContext.currentTime);
        oscillator.stop(audioContext.currentTime + 0.5); // Stop after 0.5 seconds
    },
    moveViewport(outer, inner, options = {}) {
        let isDragging = false;
        let startX = 0;
        let startY = 0;
        const state = options.sharedState || { scale: 1, translateX:0, translateY: 0 };
        let zoomSlider = null;

        const minScale = options.minScale || 0.1; // Lowered to allow zooming out further
        const maxScale = options.maxScale || 3;
        const scaleStep = options.scaleStep || 0.1;

        outer.style.overflow = 'hidden';
        outer.style.position = 'relative';
        outer.style.cursor = 'grab';

        inner.style.position = 'absolute';
        // CRITICAL FIX 1: Math requires Top-Left origin to prevent sideways drifting
        inner.style.transformOrigin = '0 0'; 
        inner.style.willChange = 'transform'; // Hardware acceleration
        
        // CRITICAL FIX 2: Ensure floats so we don't accidentally do string concatenation
        inner.style.transform = `translate(${parseFloat(state.translateX)}px, ${parseFloat(state.translateY)}px) scale(${state.scale})`;
        
        // CRITICAL FIX 3: Removed inner.style.transition = 'transform 0.05s linear' which caused the violent shaking.

        const updateTransform = (animate = false) => {
            if (zoomSlider) zoomSlider.value = state.scale.toFixed(2);
            // Only animate for buttons. Wheel/Drag must be instant.
            inner.style.transition = animate ? 'transform 0.2s ease-out' : 'none';
            inner.style.transform = `translate(${parseFloat(state.translateX)}px, ${parseFloat(state.translateY)}px) scale(${state.scale})`;
        };

        // Mouse down => start dragging
        outer.addEventListener('mousedown', e => {
            if(!options.isActive) return;
            isDragging = true;
            startX = e.clientX - parseFloat(state.translateX);
            startY = e.clientY - parseFloat(state.translateY);
            outer.style.cursor = 'grabbing';
        });

        // Mouse up => stop dragging
        window.addEventListener('mouseup', () => {
            if(!options.isActive) return;
            isDragging = false;
            outer.style.cursor = 'grab';
        });

        // Mouse move => drag content
        window.addEventListener('mousemove', e => {
            if (!isDragging || !options.isActive) return;
            state.translateX = e.clientX - startX;
            state.translateY = e.clientY - startY;
            updateTransform(false);
        });

        // Wheel zoom (cursor-centered)
        outer.addEventListener('wheel', e => {
            if(!options.isActive) return;
            e.preventDefault();
            
            const rect = inner.getBoundingClientRect();
            const offsetX = e.clientX - rect.left;
            const offsetY = e.clientY - rect.top;

            // Smoother exponential zoom math
            const zoomFactor = Math.exp(-e.deltaY * 0.002);
            let newScale = state.scale * zoomFactor;
            newScale = Math.max(minScale, Math.min(maxScale, newScale));

            if (newScale === state.scale) return; // Prevent jumping when limit is hit

            const ratio = newScale / state.scale;

            state.translateX = parseFloat(state.translateX) - offsetX * (ratio - 1);
            state.translateY = parseFloat(state.translateY) - offsetY * (ratio - 1);

            state.scale = newScale;
            updateTransform(false); // Update instantly (No shaking)
        }, { passive: false });

        // Programmatic zoom buttons
        const zoomIn = () => {
            const newScale = Math.min(state.scale + scaleStep, maxScale);
            state.translateX -= (inner.offsetWidth / 2) * (newScale / state.scale - 1);
            state.translateY -= (inner.offsetHeight / 2) * (newScale / state.scale - 1);
            state.scale = newScale;
            updateTransform(true); // Animate smoothly
        };

        const zoomOut = () => {
            const newScale = Math.max(state.scale - scaleStep, minScale);
            state.translateX -= (inner.offsetWidth / 2) * (newScale / state.scale - 1);
            state.translateY -= (inner.offsetHeight / 2) * (newScale / state.scale - 1);
            state.scale = newScale;
            updateTransform(true); // Animate smoothly
        };

        function setZoomLevel(value) {
            const clampedScale = Math.min(Math.max(value, minScale), maxScale);
            if (clampedScale === state.scale) return;

            state.translateX -= (inner.offsetWidth / 2) * (clampedScale / state.scale - 1);
            state.translateY -= (inner.offsetHeight / 2) * (clampedScale / state.scale - 1);
            state.scale = clampedScale;
            updateTransform(true);
        };

        return { zoomIn, zoomOut, setZoomLevel, attachSlider: (slider) => { zoomSlider = slider; zoomSlider.value = state.scale; },state };
    }
}

export default Utils;